module.exports = __webpack_public_path__ + "static/img/fish27.a4780f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish27.png
// module id = PxSy
// module chunks = 0